require('./cart-delivery-tip-button-toggle.scss');

var BaseViews = require('../../../base');

var TipButton = BaseViews.ItemView.extend({
    template: require('./cart-delivery-tip-button.html'),
    className: 'fmcy-delivery-tip-button',
    initialize: function (options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                active: false
            }
        );
    },
    triggers: function () {
        return {
            'click': {
                event: 'button:clicked'
            }
        };
    },
    serializeData: function () {
        return {
            label: this.model.get('label'),
            value: this.model.get('value'),
            active: this.options.active
        };
    }
});

var TipButtonToggle = Backbone.Marionette.CompositeView.extend({
    className: 'fmcy-cart-delivery-tip-button-toggle',
    template: require('./cart-delivery-tip-button-toggle.html'),
    childView: TipButton,
    childViewContainer: '.fmcy-tip-buttons',
        childEvents: {
        'button:clicked': 'onButtonClicked'
    },
    onButtonClicked: function (event) {
        this.trigger('tip:selected', event.model.get('value'));
    },
    childViewOptions: function(model, index) {
        var options = _.extend(
            {
                modelIndex: index
            },
            this.options
        );

        if (this.options.selectedValue == model.get('value')) {
            options.active = true;
        }

        return options;
    },
    initialize: function (options) {
        this.options = _.defaults(
            options || {},
            {
              toolTip: false,
              selectedValue: null
            }
        );
    },
    serializeData: function () {
        return {
            options: this.options
        };
    }
});

module.exports = TipButtonToggle;


/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-tip/cart-delivery-tip-button-toggle.js
 **/